const pending = {
  name: 'PENDING',
  dotColor: '#edc153'
}

const active = {
  name: 'ACTIVE',
  dotColor: '#85ec55'
}

const inactive = {
  name: 'INACTIVE',
  dotColor: '#ef5454'
}

const deleted = {
  name: 'DELETED',
  dotColor: '#ef5454'
}

export default {
  pending,
  active,
  inactive,
  deleted
}
